import Styles from "./main.module.css";
import Plogo from "../images/PlogoWhite.png";
import { useState } from "react";
export const Header = ( props ) => {
    const { link } = props;
    const { Header, Logo } = Styles;
    const [ display, setDisplay ] = useState(false);
    const onClick = _=>{
        const { style } = document.documentElement;
        if( display && window.innerWidth <= 500 ){
            style.setProperty("--display", "none");
            setDisplay(false);
        }
        else if( !display || window.innerWidth <= 500 ) {
            style.setProperty("--display", "flex");
            setDisplay(true);
        }
    };
    return (
        <header className={ Header }>
            <div className={ Logo }>
                <div><img src={ Plogo }/></div>
                <div></div>
                <h2>{ link }</h2>
            </div>
            <h1>Paradox</h1>
            <button style={{ display: link === "Home" && "none" }}>
                <i className="bi bi-list" onClick={ onClick }></i>
            </button>
        </header>
    );
};